import {Component, Input} from "@angular/core";
import {Order} from "../../../../objects/orders/order";
/**
 * Created by vlad.p on 9/8/2017.
 */

@Component({
    selector: "order-details-card",
    templateUrl: "order-details-card.component.html",
    moduleId: module.id.toString()
})
export class OrderDetailsCardComponent {

    @Input()
    public order: Order;

    @Input()
    public currency: string;

    @Input()
    public clonedOrder: Order;

    @Input()
    public isPublic : boolean = false;

}


// WEBPACK FOOTER //
// ./app/components/calculator/cards/order-details-card/order-details-card.component.ts